<!--
  Displays account information if a user is logged in.
-->
<template>
  <div v-if="account !== null" class="fixed top-0 right-0 bg-white z-50 py-2 px-4 shadow-sm border-b border-l border-gray-200 rounded-bl-2xl">
    <div href="#" class="flex-shrink-0 block">
      <div class="flex items-center">
        <div class="ml-3">
          <p class="text-sm font-medium text-gray-700">
            {{ account.name }} &#60;{{ account.email.toLowerCase() }}&#62;
          </p>
          <p @click="logout" class="text-right text-xs font-medium text-gray-500 hover:text-gray-700 cursor-pointer">
            Log out
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { Account, AuthenticationServiceInterface } from '@/services/authentication/authenticationServiceInterface';
import store from '@/store';
import { computed } from 'vue';

const authenticationService = injectStrict<AuthenticationServiceInterface>('AuthenticationServiceInterface');

const account = computed<Account | null>(() => {
  return store.state.account;
});

const logout = () => {
  authenticationService.doLogout();
};
</script>
